module.exports = __webpack_public_path__ + "static/media/communityImage1.618915aa.png";